import { ATTACHMENT_TYPE } from "@home-health-notify/domain";
import { ReferralImage } from "../../../../addPatientGroup/AddPatientGroup.style";
import DisplayThumbnailImage from "../../../../common/DisplayThumbnailImage";
import { getViewReferralAttachmentImage } from "../../../../uploader/FileUtils";

export default function ReferralAttachmentItemImage({
  type,
  url,
}: {
  type?: ATTACHMENT_TYPE;
  url: string;
}) {
  return (
    <>
      {type === ATTACHMENT_TYPE.JPG ? (
        <DisplayThumbnailImage
          url={url}
          alt={type}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          data-testid="referral-image"
        />
      ) : (
        <ReferralImage src={getViewReferralAttachmentImage(type)} alt={type} />
      )}
    </>
  );
}
